module.exports = __webpack_public_path__ + "static/FlutterProductMarket-adbfd2a8e1e76f61985260fb3241e4bc.png";